<div class="content-wrapper report-table-layout">
  <div class="table-section">
    <app-loading [isLoading]="loading"></app-loading>
    <p-table
      #authorsTable
      styleClass="p-datatable-sm"
      [value]="loading ? [1, 2, 3, 4, 5, 6, 7, 8, 9, 10] : authorsData"
      [scrollable]="true"
      scrollHeight="flex"
    >
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 20%">Author</th>
          <th style="width: 15%">
            <span
              class="force-pointer"
              role="button"
              href="javascript:;"
              (click)="sortChange(sortArticlesIcon)"
            >Articles
              <i id="sortArticlesIcon" class="pi pi-sort" #sortArticlesIcon></i>
            </span>
          </th>
          <th style="width: 8%">
            <span
              class="force-pointer"
              role="button"
              href="javascript:;"
              (click)="sortChange(sortFirstMentionedIcon)"
              >First
              <i
                id="sortFirstMentionedIcon"
                class="pi pi-sort"
                #sortFirstMentionedIcon
              ></i>
            </span>
          </th>
          <th style="width: 8%">
            <span
              class="force-pointer"
              role="button"
              href="javascript:;"
              (click)="sortChange(sortLastMentionedIcon)"
            >Last
              <i
                id="sortLastMentionedIcon"
                class="pi pi-sort"
                #sortLastMentionedIcon
              ></i>
            </span>
          </th>
          <th style="width: 25%">Title</th>
          <th style="width: 25%">Excerpt</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr *ngIf="!loading"
            class="clickable-row"
            (click)="getAuthorContent(item)"
        >
          <td style="width: 20%"
            [class]="sortColumn === 'name' ? 'sort-color' : ''"
          >
            <div class="author-cell">
              <app-star-toggle
                [active]="isAuthorSaved(item)"
                [isLoading]="savingAuthorId === item.authorId"
                (toggled)="onAuthorStarToggled(item, $event)"
              ></app-star-toggle>
              <img
                height="40px"
                width="40px"
                class="author-avatar"
                [src]="item.imageUrl"
              />
              <div class="author-info">
                <span
                  class="author-name"
                  [pTooltip]="item.name"
                  tooltipPosition="top"
                >
                  {{ item.name }}
                </span>
                <span
                  class="author-outlet"
                  [pTooltip]="item.outletNames"
                  tooltipPosition="top"
                >
                  {{ item.outletNames }}
                </span>
              </div>
            </div>
          </td>
          <td style="width: 15%"
            [class]="sortColumn === 'numItems' ? 'sort-color' : ''"
          >
            {{ item.numItems }}
            <p-progressBar
              [value]="item.numItemsPercentageOfMax * 100"
              [showValue]="false"
              [style]="{ height: '20px' }"
              class="coverage-progress"
            ></p-progressBar>
            <p-skeleton
              *ngIf="loading"
              width="100%"
              height="1.5rem"
            ></p-skeleton>
          </td>
          <td style="width: 8%"
            [class]="sortColumn === 'minDate' ? 'sort-color' : ''"
          >
            {{ item.minDate | date : 'MMM dd, yyyy' }}
          </td>
          <td style="width: 8%"
            [class]="sortColumn === 'maxDate' ? 'sort-color' : ''"
          >
            {{ item.maxDate | date : 'MMM dd, yyyy' }}
          </td>
          <td style="width: 25%">
            <span
              class="coverage-title p-list-title"
              role="button"
              (click)="goToTitleUrl(item.latestArticle.url)"
            >
                <span
                  *ngIf="item.latestArticle.titleExcerpt"
                  [innerHTML]="item.latestArticle.titleExcerpt"
                ></span>
              <span *ngIf="!item.latestArticle.titleExcerpt && item.latestArticle.title">
                  {{ item.latestArticle.title }}
                </span>
            </span>
          </td>
          <td style="width: 25%">
              <span
                style="font-size: 0.7rem"
                class="p-list-title"
                [innerHTML]="item.latestArticle.bodyExcerpt"
                (click)="goToTitleUrl(item.latestArticle.url)"
              ></span>
          </td>
        </tr>
        <tr *ngIf="loading">
          <td style="width: 35%">
            <p-skeleton width="100%" height="1.5rem"></p-skeleton>
          </td>
          <td style="width: 120px">
            <p-skeleton width="100%" height="1.5rem"></p-skeleton>
          </td>
          <td style="width: 120px">
            <p-skeleton width="100%" height="1.5rem"></p-skeleton>
          </td>
          <td style="width: 120px">
            <p-skeleton width="100%" height="1.5rem"></p-skeleton>
          </td>
          <td style="width: 35%">
            <p-skeleton width="100%" height="1.5rem"></p-skeleton>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr *ngIf="!loading">
          <td colspan="4" class="text-center">No records found</td>
        </tr>
      </ng-template>
    </p-table>
    <div class="pagination-footer">
      <div class="pagination-footer-left">
        <p-paginator
          #paginator
          [showCurrentPageReport]="true"
          currentPageReportTemplate="{{ totalItems | number }} total items"
          [pageLinkSize]="3"
          [showFirstLastIcon]="false"
          (onPageChange)="getPage($event)"
          [rows]="pageSize"
          [totalRecords]="totalItems"
        >
        </p-paginator>
      </div>
      <div class="report-table-footer-actions">
        <p-dropdown
          [options]="exportOptions"
          placeholder="Export Coverage"
          optionLabel="label"
          optionValue="value"
          (onChange)="handleExport($event)"
          styleClass="reports-export-dropdown p-mr-2"
          [showClear]="false"
          appendTo="body"
          [ngModel]="selectedExportValue"
        >
          <ng-template pTemplate="selectedItem" let-selectedOption>
            <div class="export-selected-item">
              <i *ngIf="isExportingExcel" class="pi pi-spin pi-spinner"></i>
              <i *ngIf="isExportingText" class="pi pi-spin pi-spinner"></i>
              <i
                *ngIf="!isExportingExcel && !isExportingText"
                class="pi pi-fw pi-download"
              ></i>
              <span class="p-ml-2">Export Coverage</span>
            </div>
          </ng-template>
          <ng-template pTemplate="item" let-option>
            <div class="export-option-item">
              <i [class]="option.icon"></i>
              <span class="p-ml-2">{{ option.label }}</span>
            </div>
          </ng-template>
        </p-dropdown>
        <button
          pTooltip="Report Missing Data"
          pButton
          class="p-button-outlined p-button-secondary p-button-sm"
          icon="pi pi-flag"
          label=""
          (click)="openReportMissingDataModal()"
        ></button>
      </div>
    </div>
  </div>
</div>
